// src/hooks/useParticipantBadges.js
import { useEffect, useState } from 'react';
import axios from '../../config/axiosInstance';

const useParticipantBadges = (participantId, host) => {
    const [badges, setBadges] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchBadges = async () => {
        if (!participantId || !host) return;
        setLoading(true);
        try {
            const tokenRes = await axios.get(`/regasus/token?host=${host}`);
            const token = tokenRes.data.access_token;

            const res = await axios.post('/regasus/get-badges-of-participant', {
                token,
                host,
                participantId
            });

            const data = Array.isArray(res.data)
                ? res.data
                : res.data?.badges?.badge || [];

            setBadges(data);
        } catch (error) {
            console.error('Error fetching badges:', error);
            setBadges([]);
        } finally {
            setLoading(false);
        }
    };

    return { badges, loading, fetchBadges };
};

export default useParticipantBadges;